import { updateCurrentUser } from '@mews-commander/core';
import { useRepositoryMutation } from '@mews-commander/data-access';

export const useDisablePinMutation = ({ onSuccess }: { onSuccess?: () => void }) =>
    useRepositoryMutation('users', 'clearUnlockPin', {
        transformParams: (_: void) => ({}),
        onSuccess: () => {
            updateCurrentUser({ hasUnlockPin: false });
            onSuccess?.();
        },
    });
